import { RefreshCw } from "lucide-react";
import { LockedSection } from "@/components/plan/common";

export default function RetargetingSection({ retargeting, locked }) {
  if (!retargeting) return null;
  return (
    <LockedSection locked={locked} icon={RefreshCw} title="Retargeting plan">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 bg-white border border-zinc-200 rounded-2xl p-5">
          <div className="text-xs uppercase tracking-widest text-zinc-500">Audiences</div>
          <div className="mt-3 space-y-3">
            {retargeting.audiences?.map((a, i) => (
              <div key={`aud-${i}-${(a.name || "").slice(0, 20)}`} className="border-t border-zinc-100 pt-3">
                <div className="font-medium text-sm">{a.name}</div>
                <div className="text-xs text-zinc-500 mt-1">{a.definition}</div>
                <div className="text-xs text-indigo-600 mt-1">Creative: {a.creative_angle}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-white border border-zinc-200 rounded-2xl p-5">
          <div className="text-xs uppercase tracking-widest text-zinc-500">Budget split</div>
          {retargeting.budget_split_percent && (
            <div className="mt-3 space-y-2">
              {Object.entries(retargeting.budget_split_percent).map(([k, v]) => (
                <div key={k}>
                  <div className="flex justify-between text-xs"><span className="capitalize">{k.replace(/_/g, " ")}</span><span>{v}%</span></div>
                  <div className="h-2 bg-zinc-100 rounded-full overflow-hidden mt-1">
                    <div className="h-full bg-indigo-600" style={{ width: `${v}%` }} />
                  </div>
                </div>
              ))}
            </div>
          )}
          <div className="mt-4 text-xs uppercase tracking-widest text-zinc-500">Sequence</div>
          <ul className="mt-2 space-y-1 text-sm">
            {retargeting.sequence?.map((s, i) => <li key={`seq-${i}-${s.slice(0, 20)}`}>• {s}</li>)}
          </ul>
        </div>
      </div>
    </LockedSection>
  );
}
